function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4EA15A",
  fillRule: "nonzero",
  d: "M14.17 3.336a2.5 2.5 0 012.5 2.5v8.334a2.5 2.5 0 01-2.5 2.5H5.836a2.5 2.5 0 01-2.5-2.5V5.836a2.5 2.5 0 012.5-2.5h8.334z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4EA15A",
  fillRule: "nonzero",
  d: "M13.818 5.415H6.179a.764.764 0 00-.759.675l-.005.089v7.639c0 .392.295.715.675.759l.089.005h7.639a.764.764 0 00.759-.675l.005-.09V6.18a.764.764 0 00-.675-.759l-.09-.005z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 2.708,
  fill: "#4EA15A",
  fillRule: "nonzero"
}));

function SvgGivenFeedbackActivityBadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20
  }, props), _ref);
}

export default SvgGivenFeedbackActivityBadgeIcon;